import {removeAuth,auth} from "./permission/auth";


 
const directivesList:any = {
  removeAuth,
  auth
};
 
const directives = {
  install: function (app:any) {
    Object.keys(directivesList).forEach((key) => {
      app.directive(key,directivesList[key]); // 注册
    });
  }
};
 
export default directives;